<div class="card item_card" [id]="place.id" style="max-width: 16rem; min-width: 16rem;">
  <div class="card-body item_card_res d-inline-flex align-items-center" >
    <div class=" col-sx-2">
        <div>
          <span class="fa-stack fa-2x parking-Icon" style="cursor: pointer;" [title]="place.type" (click) ="gotoMap(place)">
              <i class="far fa-square fa-stack-2x " style="color:gray"></i>
              <i *ngIf ="place.busy" class=" fa-stack-1x fas fa-car "
               [ngClass]="carColor"></i>
          </span>
          <span (click)="editPlace(place.id)"  [title]="'Editer les information'">
            <span >
            <i class="fas fa-edit" ></i>
            </span>
          </span>
        </div>

    </div>
    <div class="text_section col-sx-9">
      <div class="d-flex flex-column">
      <div>
      <div class="card-text">
        </div>
      </div>
    </div>
    <div *ngIf="checkble" class="col-sx-1 " style="margin-right: 10px;">
      <input type="checkbox" [value]="place.id" (change)="this.addremoveConfig()"
      [(ngModel)]="isPlaceCheck" >
    </div>
  </div>
  </div>
  <div *ngIf="!checkble" class="card-footer">
    <p><i class="fas fa-map-marked-alt"></i> {{place.street}}</p>
    <P>Place N° : {{place.label}}</P>
    <div class="item_categorie" >
      <div *ngIf="place.busy">
            <p>Place Occupée
            <span [class]="countDownColor" id="countDown"> {{(countDown)}}</span>
              <span (click)="addTime(place.id)" [title]="'Ajouter du temps'">
                <span class="fa-stack addTime-Icon" [title]="place.type">
                    <i class="far fa-clock fa-stack-1x " ></i>
                    <i class="parking-type fa-stack-1x fas fa-plus "
                      [ngClass]="carColor"></i>
                </span>
              </span>
            </p>
        </div>
        <div *ngIf="!place.busy" style=" padding-bottom:8px">
            <p>Place Libre</p>
        </div>
    </div>
      <!-- <div class="item_categorie" class="d-flex flex-row" style="align-items: baseline;"> -->
          <!-- <div (click)="editPlace(place.id)"  [title]="'Editer les information'">
            <span >
            <i class="fas fa-edit" ></i>
            </span>
          </div> -->
          <!-- <div *ngIf="place.busy" (click)="addTime(place.id)" [title]="'Ajouter du temps'">
              <span class="fa-stack addTime-Icon" [title]="place.type">
                  <i class="far fa-clock fa-stack-1x " ></i>
                  <i class="parking-type fa-stack-1x fas fa-plus "
                   [ngClass]="carColor"></i>
              </span>
          </div> -->
      <!-- </div> -->
  </div>
</div>
